import { useNotificationChannel } from '../useNotificationChannel';

import { EmailChannelFields } from './EmailChannelFields';
import { MsTeamsChannelFields } from './MsTeamsChannelFields';
import { SlackChannelFields } from './SlackChannelFields';
import { ChannelFieldsProps } from './types';
import { UnknownChannelFields } from './UnknownChannelFields';
import { WebhookChannelFields } from './WebhookChannelFields';

export function ChannelConfigurationFields({ index }: ChannelFieldsProps) {
  const channel = useNotificationChannel(index);

  switch (channel.type) {
    case 'slack':
      return <SlackChannelFields index={index} />;
    case 'email':
      return <EmailChannelFields index={index} />;
    case 'webhook':
      return <WebhookChannelFields index={index} />;
    case 'msteamsv2':
      return <MsTeamsChannelFields index={index} />;
    case 'discord':
    case 'opsgenie':
    case 'pagerduty':
    default:
      return <UnknownChannelFields index={index} />;
  }
}
